var _path, _path2, _line, _line2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTimeIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 24.0001C7 17.925 11.9249 13.0001 18 13.0001C24.0751 13.0001 29 17.925 29 24.0001C29 30.0753 24.0751 35.0001 18 35.0001C11.9249 35.0001 7 30.0753 7 24.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7816 18.0006L17.7815 25.0006L23.0771 25.0007",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 10.3751,
    x2: 22,
    y2: 10.3751,
    stroke: "white",
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 10.5001,
    x2: 18,
    y2: 13.5001,
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.552 5.68012H28.832V3.34012H30.368V5.68012H32.636V7.16812H30.368V9.50812H28.832V7.16812H26.552V5.68012Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.552 13.6801H34.832V11.3401H36.368V13.6801H38.636V15.1681H36.368V17.5081H34.832V15.1681H32.552V13.6801Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTimeIconWhite);
export default __webpack_public_path__ + "static/media/chat-time-icon-white.7248d798f799b6fdbf52ab6b97fe32ed.svg";
export { ForwardRef as ReactComponent };